import { defineEntity, lifecycle, custom } from './_helpers.js';

/** Leftover Risk model catalog. No live producer — hidden from automation palette. */
const leftoverRisk = defineEntity('risk', {
    reviewDue:       lifecycle({ deprecated: true }),
    statusChanged:   custom({ scope: 'state', deprecated: true }),
    treatmentAdded:  custom({ scope: 'state', deprecated: true }),
});

for (const def of Object.values(leftoverRisk.events)) {
    def.deprecated = true;
}

export default leftoverRisk;
